import React, {Component} from "react";
import styles from './FJVideoTool.module.less';
import FJSlider from "fj-components/FJSlider";
import FJIconButton from "../../../../../common/component/button-icon/FJIconButton";
import PlayIcon from '../../../../../icon/play.svg';
import StopIcon from '../../../../../icon/stop.svg';
import InlineSVG from "react-inlinesvg";
import FJPreviewVolumeView from "./FJPreviewVolumeView";
import classNames from 'classnames';

class FJVideoTool extends Component{

	constructor(props) {
		super(props);

		this.slider =  {
				sliderBoxClassName: styles.slider_box,
				railClassName: styles.rail,
				trackClassName: styles.track,
				handleClassName: styles.handle,
		}
	}

	_onClick = (e) => {
	  e.stopPropagation();
	  e.preventDefault();
  };

	render() {

		let {
			isPlaying,
			play,
			onBeforeChange,
			onChange,
			onAfterChange,
			disabled,
			progress,
			currentTime,
			totalTime,
			setVideoVolume,
			isLoaded,
			volume
		} = this.props;

		return (
			<div className={classNames(styles.tool_container, {[styles.active]: isLoaded})} onClick={this._onClick}>
				<div className={styles.preview_controller}>
					<div className={styles.preview_progress}>
						<FJSlider progress={progress}
											classes={this.slider}
											onBeforeChange={onBeforeChange}
											onChange={onChange}
											onAfterChange={onAfterChange}
											disabled={disabled}
						/>
					</div>
					<div className={styles.btn_container}>
						<FJIconButton icon={<InlineSVG src={isPlaying ? StopIcon : PlayIcon}/>}
													className={styles.play}
													onClick={play}
						/>
						<FJPreviewVolumeView setVideoVolume={setVideoVolume} volume={volume}/>
						<span className={styles.duration}>{currentTime} / {totalTime}</span>
					</div>
				</div>
			</div>
		)
	}

}

export default FJVideoTool;
